// extracted by mini-css-extract-plugin
export const button = "button-module--button--d3l5c";
export const fill = "button-module--fill--2KTCp";
export const outline = "button-module--outline--j7zVY";